<template>
  <GreyBarWithTitleAndValue
      is-with-borders
      title = "TripBits Guides"
      :value = "$numberManagement.numberWithComma(itemData)"
  />
</template>

<script>

import GreyBarWithTitleAndValue from '../../../microcomponents/GreyBarWithTitleAndValue.vue';

export default {
  name: 'GrayBarGuidesNumber',
  components: {
    GreyBarWithTitleAndValue,
  },

  props: {
    itemData: {
      type: [Number, String],
      default: null,
    },
  },
};
</script>
